import { combineReducers } from 'redux';
import sns from './sns';

const join = combineReducers({
	sns,
});

export default join;
